import { create } from "zustand";

import { useDebounce } from "Utilities/Hooks/useDebounce";

const useGroupCommunicationStore = create((set) => ({
  searchValue: "",
  setSearchValue: (newSearchValue) => set({ searchValue: newSearchValue }),
  searchContainerRef: { current: null },
}));

const useSearchValue = () => {
  const searchValue = useGroupCommunicationStore((s) => s.searchValue);
  const setSearchValue = useGroupCommunicationStore((s) => s.setSearchValue);

  return [searchValue, setSearchValue];
};

const useDebouncedSearchValue = () => {
  const [searchValue] = useSearchValue();
  return useDebounce(searchValue, 230);
};

const useSearchContainerRef = () =>
  useGroupCommunicationStore((s) => s.searchContainerRef);

export { useSearchValue, useDebouncedSearchValue, useSearchContainerRef };
